import type { AdminRouteName, TenantSettings } from '@lastrouter/contracts';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ApiError } from '../api/client.js';
import { errorMessage, useApiMutation } from '../api/hooks.js';

/**
 * Grava as configurações com a versão que a pessoa estava vendo. Se outra pessoa gravou antes
 * (409), avisa e recarrega, em vez de sobrescrever a mudança alheia.
 */
export function useSaveSettings(successKey: string, extraInvalidate: AdminRouteName[] = []) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const m = useApiMutation('putSettings', ['settings', ...extraInvalidate]);
  return {
    pending: m.isPending,
    save(settings: TenantSettings, onDone?: () => void) {
      m.mutate(
        { body: { settings, expected_version: settings.version } },
        {
          onSuccess: () => {
            toast.success(t(successKey));
            onDone?.();
          },
          onError: (err) => {
            if (err instanceof ApiError && err.status === 409) {
              toast.error(t('errors.conflict'));
              void qc.invalidateQueries({ queryKey: ['settings'] });
            } else toast.error(errorMessage(t, err));
          },
        },
      );
    },
  };
}
